import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"

import variables from "../../Styles/Pallette.scss"

const styles = [
  {
    type: "info",
    icon: "fas fa-info-circle",
    color: variables.infoMain,
  },
  {
    type: "warning",
    icon: "fas fa-exclamation-triangle",
    color: variables.warningMain,
  },
  {
    type: "error",
    icon: "fas fa-bomb",
    color: variables.errorMain,
  },
  {
    type: "success",
    icon: "fas fa-thumbs-up",
    color: variables.successMain,
  },
  {
    type: "none",
    icon: "fas fa-envelope",
  },
]

function MessageBox(props) {
  const { severity, message, variant, elevation } = props

  const style = styles.find((style) => severity === style.type)

  if (!style) return

  return (
    <Paper variant={variant ?? "elevation"} elevation={elevation ?? 3}>
      <Grid container wrap="nowrap">
        <Grid item style={{ paddingRight: "0.5rem" }}>
          <span className={style.icon} style={{ color: style.color }} />
        </Grid>

        <Grid item>
          <p>{message}</p>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default MessageBox
